<ng-container>
  <app-applicants (hasCoApplicantEvent)="hasCoApplicant($event)"></app-applicants>
  <app-bsa-profile
    *ngIf="!shouldHideBsaQuestions"
    [reviewState]="reviewState"
    [hasCoApplicant]="applicationHasCoApplicant"
  ></app-bsa-profile>
</ng-container>

